class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				// path: '/backend/fetch/contacts'
				path: '/backend/fetch/all/contacts'
			},
			fetchBlockedContacts: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/fetch/blocked/contacts'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/backend/user/:id/attributes'
			},
			updateCustomerProfile: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/customer/attributes'
			},
			fetch: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/fetch/customer/:number'
			},
			fetchCustomerProfile: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/customer/profile'
			},
			contactsCsvUpload: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/add/customers'
			},
		};
	}
}

export default new APIS();
